import { EditorialOffer } from '../types/editorial-offer.type';

import largeCompanyIllustration from '../../assets/img/entreprise-1.png';
import smallCompanyIllustration from '../../assets/img/entreprise-3.png';

// Contenu relevé sur la page legacy /offre-entreprise
// (src/views/Front/Entreprises/OffreEntreprise.js).
export const ENTERPRISE_OFFER_HERO = {
  // Le legacy titre « l'offre entreprise : àdaptée à chaque besoin », avec une minuscule initiale
  // et un accent fautif sur « àdaptée ».
  title: "L'offre entreprise, adaptée à chaque besoin",
  lead: 'Offrez un service de qualité à vos salariés en proposant la livraison de paniers de fruits et légumes bio au bureau.',
};

// Les deux offres portent les mêmes critères, dans le même ordre : c'est ce qui rend la comparaison
// possible d'une colonne à l'autre.
export const ENTERPRISE_OFFERS: EditorialOffer[] = [
  {
    illustration: smallCompanyIllustration,
    illustrationAlt: 'Un immeuble isolé',
    title: 'De 5 à 100 salariés',
    subtitle: 'Une plateforme de commandes groupées',
    specs: [
      { label: 'Mise en place', value: '20 minutes' },
      { label: 'Suivi', value: "5 à 7 minutes à chaque lancement d'invitation" },
      { label: 'Paiement', value: 'Chacun paie sa commande directement sur notre site' },
      { label: 'Avantage', value: 'Je bénéficie d’Eco-points sur mes commandes' },
    ],
    ctaLabel: 'Contactez-nous',
    ctaPath: null,
    processTitle: 'Avec la plateforme de commandes groupées',
    processSteps: [
      'Je crée mon compte sur la plateforme collaborative « Bio Culture et Vous ».',
      'J’enregistre sur mon tableau de bord les collègues intéressés.',
      'Je lance, quand je le souhaite, une invitation à une commande groupée.',
      "Je suis livré de l'ensemble des paniers commandés, le jour que j'ai choisi. Les paniers sont nominatifs.",
    ],
  },
  {
    illustration: largeCompanyIllustration,
    illustrationAlt: 'Un groupe de trois immeubles',
    title: 'De 100 à plusieurs milliers de salariés',
    subtitle: 'Un code entreprise pour chacun des salariés',
    specs: [
      { label: 'Mise en place', value: '15 minutes' },
      { label: 'Suivi', value: 'Communication ponctuelle' },
      { label: 'Paiement', value: 'Chacun paie sa commande directement sur notre site' },
      { label: 'Avantage', value: 'Gestion simple et autonomie de chacun' },
    ],
    ctaLabel: 'Contactez-nous',
    ctaPath: null,
    processTitle: 'Avec un code entreprise',
    processSteps: [
      "Lors d'un appel de 10 minutes avec Bio Culture, je définis mes besoins : jour de livraison, choix du code entreprise.",
      'Je communique à tous les salariés un code entreprise, qui leur permet de commander en toute autonomie sur le site.',
      "Le jour qui a été défini, je suis livré de l'ensemble des paniers commandés. Les paniers sont nominatifs.",
    ],
  },
];
